import { render, staticRenderFns } from "./ArticleForm.vue?vue&type=template&id=39a78b30&"
import script from "./ArticleForm.vue?vue&type=script&lang=ts&"
export * from "./ArticleForm.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleForm.vue?vue&type=style&index=0&id=39a78b30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports